import "./App.css";
import logo from "./assets/luniwave.png";
import luniwaveLogo from "./assets/logo_rond.png";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import ScrollRestoration from "./components/ScrollRestoration";

// Pages principales LuniShower
import Home from "./pages/Home";
import AddHotel from "./pages/AddHotel";
import PerformancesPage from "./pages/PerformancesPage";
import RoomPage from "./pages/RoomPage";
import LuniShowerHome from "./pages/LuniShower/LuniShowerHome";

// Pages GreenMiles
import GreenMilesHome from "./pages/GreenMiles/GreenMilesHome";
import CreateActionPageV2 from "./pages/GreenMiles/CreateActionPageV2";
import EditActionPage from "./pages/GreenMiles/EditActionPage";
import EditRewardPage from "./pages/GreenMiles/EditRewardPage";
import CreateRewardPageV2 from "./pages/GreenMiles/CreateRewardPageV2";
import CreateGreenMilesHotelPage from "./pages/GreenMiles/CreateGreenMilesHotelPage";
import GreenMilesRoomNumberManager from "./pages/GreenMiles/GreenMilesRoomNumberManager";
import GreenMilesDemos from "./pages/GreenMiles/GreenMilesDemos";
import CreateGreenMilesDemoPage from "./pages/GreenMiles/CreateGreenMilesDemoPage";
import GreenMilesDemoPage from "./pages/GreenMiles/GreenMilesDemoPage";
import GreenMilesStatsPage from "./pages/GreenMiles/GreenMilesStatsPage";
import GreenMilesStaysPage from "./pages/GreenMiles/GreenMilesStaysPage";
import ImagesPage from "./pages/ImagesPage";

// Pages Plateforme Luniwave
import AccessManagement from "./pages/LuniApp/AccessManagement";

import UnifiedHotelPage from "./pages/UnifiedHotelPage";
import MailsSuccessPage from "./pages/MailsSuccessPage";

// Pages spécialisées
import Alertes from "./pages/Alertes/Alertes";
import RoomAlerts from "./pages/Alertes/RoomAlerts";
import SyncShowersPage from "./pages/SyncShowersPage";
import RoomNumberManager from "./pages/RoomNumberManager";

import { useAuth } from "react-oidc-context";

function App() {
  const auth = useAuth();

  const login = () => {
    auth.signinRedirect();
  };

  const logout = () => {
    auth.signoutRedirect();
  };

  if (auth.isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <div className="text-center">
          <img src={luniwaveLogo} alt="Luniwave Logo" className="w-20 h-20 animate-spin mx-auto" />
          <p className="mt-4 text-xl">Chargement en cours...</p>
        </div>
      </div>
    );
  }

  if (!auth.isAuthenticated) {
    return (
      <div className="min-h-screen bg-[#98B77F] relative flex items-center justify-center">
        <img src={logo} alt="Logo" className="absolute top-4 left-4 max-w-[150px] h-auto" />
        <div className="bg-white p-8 rounded-lg shadow-lg text-center">
          <h1 className="text-2xl font-bold mb-4">Se connecter à LuniManager</h1>
          <button onClick={login} className="bg-[#365644] text-white py-2 px-4 rounded hover:bg-[#2d4c3c] transition duration-300">
            Se connecter
          </button>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <ScrollRestoration />
      <Routes>
        <Route path="/" element={<Navigate to="/hotels" replace />} />
        <Route path="/hotels" element={<Home />} />
        <Route path="/addHotel" element={<AddHotel />} />
        <Route path="/performances" element={<PerformancesPage />} />
        <Route path="/mails-success" element={<MailsSuccessPage />} />
        <Route path="/hotels/:hotel_id/rooms/:id" element={<RoomPage />} />
        <Route path="/hotels/:hId/syncShowers" element={<SyncShowersPage />} />
        <Route path="/hotels/:id/room-numbers" element={<RoomNumberManager />} />
        <Route path="/hotels/:id/greenmiles" element={<UnifiedHotelPage />} />
        <Route path="/hotels/:id/greenmiles/:greenMilesTab" element={<UnifiedHotelPage />} />
        <Route path="/hotels/:id" element={<UnifiedHotelPage />} />

        {/* Pages LuniShower */}
        <Route path="/lunishower" element={<LuniShowerHome />} />

        {/* Pages GreenMiles */}
        <Route path="/greenmiles" element={<GreenMilesHome />} />
        <Route path="/greenmiles/create-hotel" element={<CreateGreenMilesHotelPage />} />
        <Route path="/hotels/:id/greenmiles/room-numbers" element={<GreenMilesRoomNumberManager />} />
        <Route path="/hotels/:hotelId/greenmiles/create-action" element={<CreateActionPageV2 />} />
        <Route path="/hotels/:hotelId/greenmiles/create-action-v2" element={<CreateActionPageV2 />} />
        <Route path="/hotels/:hotelId/greenmiles/actions/:actionId/edit" element={<EditActionPage />} />
        <Route path="/hotels/:hotelId/greenmiles/create-reward" element={<CreateRewardPageV2 />} />
        <Route path="/hotels/:hotelId/greenmiles/create-reward-v2" element={<CreateRewardPageV2 />} />
        <Route path="/hotels/:hotelId/greenmiles/rewards/:rewardId/edit" element={<EditRewardPage />} />

        {/* Pages GreenMiles Demos */}
        <Route path="/greenmiles/demos" element={<GreenMilesDemos />} />
        <Route path="/greenmiles/create-demo" element={<CreateGreenMilesDemoPage />} />
        <Route path="/greenmiles/demos/:id" element={<GreenMilesDemoPage />} />
        <Route path="/greenmiles/statistiques" element={<GreenMilesStatsPage />} />
        <Route path="/greenmiles/sejours" element={<GreenMilesStaysPage />} />
        <Route path="/images" element={<ImagesPage />} />
        {/* <Route path="/greenmiles/analytics" element={<GreenMilesAnalytics />} /> */}

        {/* Routes d'alertes (maintenues pour compatibilité) */}
        <Route path="/alertes" element={<Alertes />} />
        <Route path="/hotels/:hotel_id/rooms/:room_id/alerts" element={<RoomAlerts />} />

        {/* Routes Plateforme Luniwave */}
        <Route path="/luniapp/access" element={<AccessManagement />} />
      </Routes>
    </Router>
  );
}

export default App;
